"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ErrorDialog", {
  enumerable: true,
  get: function get() {
    return _ErrorDialog.ErrorDialog;
  }
});

var _ErrorDialog = require("./ErrorDialog");